var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:_vm.propClass,attrs:{"size":_vm.propSize,"variant":_vm.propVariant},on:{"click":function($event){return _vm.clickLogout()}}},[_vm._v("ログアウト")])
}
var staticRenderFns = []

export { render, staticRenderFns }